import { reportInventoryPercentagesTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_INVENTORY_PERCENTAGES_FILTERS,
  RESTORE_INITIAL
} = reportInventoryPercentagesTypes;

const getInitialState = () => ({
  date: newDate({ monthType: true }),
  station: null,
});

export const reportInventoryPercentagesReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_INVENTORY_PERCENTAGES_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
